<template>
  <div class="pb-3 order-grid-wrapper">
      <div class="subheader-wrapper">
        <div class="d-flex align-items-center">
          <h5 v-if="gridIndex > 0" class="mb-0">{{ `(${gridIndex}) ${OrderLineGroupName}` }}</h5>
          <h5 v-else class="mb-0">{{ `${OrderLineGroupName}` }}</h5>
          <div v-if="false && !gridIndex && !readOnly" class="btn btn-primary btn-sm ml-4" @click="launchSmartCatalogModal">SmartCatalog Search</div>
          <div v-if="!gridIndex && !readOnly && !isLimitedTransferUser" class="btn btn-primary btn-sm ml-4" @click="launchSmartCatalogModalNew">SmartCatalog Search</div>
          <div v-if="!gridIndex && !readOnly && !isLimitedTransferUser" class="btn btn-primary btn-sm ml-4" @click="launchConfiguratorModalV2">Configurator</div>
          <div v-if="(isHSUS || isZAHN) && !gridIndex && !readOnly && !isLimitedTransferUser" class="btn btn-primary btn-sm ml-4" @click="openPriceGuidance">Price Guidance</div>
          <div v-if="(isHSUS) && !gridIndex && !readOnly && !isLimitedTransferUser" class="btn btn-primary btn-sm ml-4" @click="openCurrentPromotions">Current Promotions</div>

          <div v-if="gridIndex && !readOnly" class="bundle-relocate-wrapper" >
            <i class="fa fa-caret-up bundle-relocate-icon" @click="$emit('moveBundleUp',OrderLineGroupId)" aria-hidden="true"></i>
            <i class="fa fa-caret-down bundle-relocate-icon" @click="$emit('moveBundleDown',OrderLineGroupId)" aria-hidden="true"></i>
          </div>
        </div>
        <div v-if="!readOnly" class="icon-group">
          <i class="fa fa-plus"     @click="addNewRow"               aria-hidden="true"></i>
          <i class="fa fa-cubes"    @click="toggleCreateBundleModal"         aria-hidden="true"></i>
          <i v-if="!gridIndex && iconSetToSelectAll" class="far fa-check-square"     @click="selectAllClicked()"               aria-hidden="true"></i>
          <i v-if="!gridIndex && !iconSetToSelectAll" class="far fa-square"     @click="deselectAllClicked()"               aria-hidden="true"></i>
          <i v-if="gridIndex && !readOnly" class="fa fa-edit" @click="openEditBundleModal" aria-hidden="true"></i>
          <i v-if="gridIndex && !readOnly" class="fa fa-trash" @click="toggleDeleteBundle" aria-hidden="true"></i>
          <!-- <i class="fa fa-copy" @click="copyOrderLines" aria-hidden="true"></i> -->
        </div>
      </div>
      <hr>
    
    <DxDataGrid
      :ref="refName"
      key-expr="LineNumber"
      :key="datagridUpdateKey"
      :data-source="dataSource"
      :show-row-lines="showRowLines"
      :show-column-lines="showColumnLines"
      :row-alternation-enabled="alternateRowEnabled"
      :allow-column-resizing="true"
      :column-resizing-mode="columnResizingMode" 
      width="100%"
      :column-min-width="25"
      :row-width="20"
      :show-borders="true"
      :column-auto-width="false"
      :filter-value="filterExpr"
      :on-cell-prepared="onCellPrepared"
      @editor-preparing="onEditorPreparing"
      @editing-start="onEditingStart"
      @row-updated="setCalculatedValues"
      :on-context-menu-preparing="addMenuItems"
      @init-new-row="initNewRow"
    >
      <DxPaging :enabled="false" />
      <DxSorting mode="none"/>
      <DxRowDragging
        v-if="!readOnly"
        :data="OrderLineGroupId"
        :on-add="onAdd"
        :allow-reordering="true"
        :on-reorder="onReorder"
        group="tasksGroup" 
      />
      <DxSelection
        v-if="multiSelect"
        select-all-mode="allPages"
        show-check-boxes-mode="always"
        mode="multiple"
      />
      <DxStateStoring
        :enabled="false"
        type="localStorage"
        storage-key="orderLinesStorage"
      />
      
      <DxEditing
        v-if="!readOnly"
        :allow-updating="true"
        :allow-adding="false"
        :allow-editing="true"
        :on-add="onAdd"
        :select-text-on-edit-start="true"
        :allow-deleting="true"
				:confirm-delete="true"
        :useIcons="true"
        mode="cell"
      />
      <!-- <DxColumn :width="40" data-field="LineNumber"         caption="Line"   header-cell-template="title-header" cell-template="grid-cell" :allowEditing="false"/> -->
      <DxColumn :width="40" data-field="Quantity"   caption="Qty"    header-cell-template="title-header" cell-template="grid-cell"/>
      <!-- <DxColumn :width="40" data-field="MfgCode"        caption="MFI"    header-cell-template="title-header" cell-template="grid-cell"/>
      <DxColumn :width="60" data-field="PartNumber" caption="Part #" header-cell-template="title-header" cell-template="grid-cell"/> -->
      <DxColumn
        :min-width="65"
        :width="65"
        :allow-sorting="false"
        :allowEditing="true"
        data-field="MfgCode"
        caption="MFI"
        header-cell-template="title-header"
        cell-template="grid-cell-dropdown"
        edit-cell-template="dropDownBoxEditorMFI"
        
      >
        <DxLookup
          :data-source="dataSource"
          display-expr="MfgCode"
          value-expr="LineNumber"
        />
      </DxColumn>
      <DxColumn
        :min-width="75"
        :width="75"
        :allowEditing="true"
        :allow-sorting="false"
        data-field="PartNumber"
        caption="Part #"
        header-cell-template="title-header"
        cell-template="grid-cell-dropdown"
        edit-cell-template="dropDownBoxEditorPartNumber"
        
      >
        <DxLookup
          :data-source="dataSource"
          display-expr="PartNumber"
          value-expr="LineNumber"
        />
      </DxColumn>
      <DxColumn
        :min-width="100"
        :allow-sorting="false"
        caption="Description"
        data-field="Description"
        header-cell-template="title-header"
        cell-template="grid-cell-dropdown-desc"
        edit-cell-template="dropDownBoxEditor"
      >
        <DxLookup
          :data-source="dataSource"
          display-expr="Description"
          value-expr="LineNumber"
        />
      </DxColumn>
      <DxColumn                       :width="detailView ? 70 : 100" data-field="Retail"            caption="Retail"             header-cell-template="title-header"  cell-template="grid-cell-amount"/>
      <DxColumn :visible="detailView" :width="detailView ? 70 : 100" data-field="DealerCost"        caption="Dealer Cost"        header-cell-template="title-header"  cell-template="grid-cell-amount"/>
      <DxColumn :visible="detailView" :width="detailView ? 70 : 100" data-field="Discount1"         caption="Discount A"           header-cell-template="title-header"  cell-template="grid-cell-percent"/>
      <DxColumn :visible="detailView" :width="detailView ? 70 : 100" data-field="Discount2"         caption="Discount B"           header-cell-template="title-header"  cell-template="grid-cell-percent" />
      <DxColumn :visible="detailView" :width="detailView ? 70 : 100" data-field="DealerExtended"    caption="Dealer Extended"    header-cell-template="title-header"  cell-template="grid-cell-amount" :allowEditing="false"/>
      <DxColumn                       :width="detailView ? 70 : 100" data-field="CustomerCost"      caption="Customer Cost"      header-cell-template="title-header"  cell-template="grid-cell-amount"/>
      <DxColumn                       :width="detailView ? 70 : 100" data-field="CustomerExtended"  caption="Customer Extended"  header-cell-template="title-header"  cell-template="grid-cell-amount" :allowEditing="false"/>
      <DxColumn :visible="detailView" :width="detailView ? 70 : 100" data-field="GPPercent"         caption="GP"                 header-cell-template="title-header"  cell-template="grid-cell-percent"/>

      <DxColumn
        :width="detailView ? 70 : 100" 
        data-field="StockCode"
        caption="Stock Code"
        header-cell-template="title-header"
        cell-template="grid-cell-stockcode"
      />

      <DxColumn
        :visible="false"
        data-field="OrderLineGroupName"
        data-type="string"
      />
      <DxColumn
        :visible="false"
        data-field="OrderLineGroupId"
        data-type="number"
      />
      <DxColumn
        :visible="false"
        data-field="PrintOptionId"
        data-type="number"
      />

			<DxColumn
				:min-width="75"
        :fixed="true"
        caption=""
        type="buttons"
        alignment="right"
      >
				<DxButton key="delete"
					text="Delete Line"
					icon="trash"
					:visible="!readOnly"
					hint="Delete Line"
					:on-click="lineDelete" />

				<DxButton key="open"
					text="Line Details"
					icon="info"
					:visible="true"
					hint="Line Details"
					:on-click="lineDetails" />
			</DxColumn>        

      <template #title-header="{ data }">
        <div class="header"  style="fontSize: 16">{{ data.column.caption }}</div>
      </template>
      <template  #grid-cell="{ data }">
          <div :class="dataHasBeenChangedByUser(data) ? 'cell-edited' : 'cell'">{{ data.text }}</div>
      </template>
      <template  #grid-cell-stockcode="{ data }">
          <div :class="dataIsNoMatch(data) ? 'cell-edited no-match' : 'cell'">{{ dataIsNoMatch(data) ? '\u00A0' : data.text }}</div>
      </template>
      <template  #grid-cell-amount="{ data }">
          <div :class="calculateAmountClass(data)">
							${{ formatCurrency(data.value) }}
					</div>
      </template>
      <template  #grid-cell-percent="{ data }">
          <div :class="calculateAmountClass(data)">
						{{ formatPercent(data.value) }}%
					</div>
      </template>
      <template  #grid-cell-dropdown="{ data }">
          <div :class="dataHasBeenChangedByUser(data) ? 'cell-edited' : 'cell'">{{ data.value }}</div>
      </template>
      <template  #grid-cell-dropdown-desc="{ data }">
          <div :class="dataHasBeenChangedByUser(data) ? 'cell-edited' : 'cell'">
            {{ data.value.substring(0, maxDescriptionLength) }}<span style="color: #AAA">{{ data.value.substring(maxDescriptionLength) }}</span>
          </div>
      </template>

      <template  #dropDownBoxEditorMFI="{ data : cellInfo}">
        <DescriptionComboboxSearch
          ref="mfg"
          cellEditing="MfgCode"
          :value="cellInfo.value"
          :on-value-changed="cellInfo.setValue"
          @setProductData="setProductData"
          
        />
      </template>
      <template #dropDownBoxEditorPartNumber="{ data : cellInfo}">
        <DescriptionComboboxSearch

          cellEditing="PartNumber"
          :value="cellInfo.value"
          :on-value-changed="cellInfo.setValue"
          @setProductData="setProductData"

        />
      </template>
      <template #dropDownBoxEditor="{ data : cellInfo}">
        <DescriptionComboboxSearch

          cellEditing="Description" 
          :value="cellInfo.value"
          :on-value-changed="cellInfo.setValue"
          @setProductData="setProductData"

        />
      </template>
    <DxSummary :key="summaryUpdateKey" :calculate-custom-summary="calculateSummary">
      <DxTotalItem
        name="SubtotalLabel"
        summary-type="custom"
        display-format="{0}"
        show-in-column="Quantity"
        cssClass="subtotal-header-customer-order-grid"
      />
      <DxTotalItem
        name="retailSummary"
        summary-type="custom"
				display-format="${0}"
        show-in-column="Retail"
        :cssClass="calculateSummaryClass('retail')"
      />
      <DxTotalItem
        name="DealerCostSummary"
        summary-type="custom"
        display-format="${0}"
        show-in-column="DealerCost"
        :cssClass="calculateSummaryClass('dealerCostSummary')"
      />
      <DxTotalItem
        name="DealerExtendedSummary"
        summary-type="custom"
        :display-format="'${0}'"
        show-in-column="DealerExtended"
        :cssClass="calculateSummaryClass('dealerCost')"
      />
      <DxTotalItem
        name="CustomerCostSummary"
        summary-type="custom"
        :display-format="'${0}'"
        show-in-column="CustomerCost"
        :cssClass="calculateSummaryClass('customerCostSummary')"
      />
      <DxTotalItem
        name="CustomerExtendedSummary"
        summary-type="custom"
        :display-format="'${0}'"
        show-in-column="CustomerExtended"
        :cssClass="calculateSummaryClass('subtotal')"
      />
      <!-- <DxTotalItem
        name="Discount1Summary"
        summary-type="custom"
        :display-format="'{0}%'"
        show-in-column="Discount1"
      />
      <DxTotalItem
        name="Discount2Summary"
        summary-type="custom"
        :display-format="'{0}%'"
        show-in-column="Discount2"
      />
      <DxTotalItem
        name="GPPercentSummary"
        summary-type="custom"
        :display-format="'{0}%'"
        show-in-column="GPPercent"
      /> -->
    </DxSummary>
    </DxDataGrid>
    <dx-tooltip :ref="tooltipRefName" position="top">
      <div class="tooltipContent">
        <div>{{currentCellToolTip}}</div>
      </div>
    </dx-tooltip>
    <Modal ref="deleteBundleModal">
      <div class="card modal-wrapper p-4">
        <p class="m-0">Are you sure you would like</p> 
        <p class="mt-0 ">to delete this bundle?</p>
        <div class="btn-wrapper center row">
            <button class="btn btn-secondary mb-2 col-12" @click="toggleDeleteBundle">Cancel</button>
            <button @click="deleteBundleAndKeepOrderLines" class="btn btn-primary mb-2 col-12">Delete Bundle</button>
            <button @click="deleteBundle" class="btn btn-primary col-12">Delete Bundle and Contents</button>
        </div>
      </div>
    </Modal>
    <Modal  ref="bundleModal">
      <div class="card modal-card">
        <BasicTextInput label="Bundle Title" class="my-1" v-model="newBundleTitle"/>
        <BasicDropdown label="Print Options" class="my-3" @change="resetBundleQuantity" :items="bundlePrintOptionsItemsNew" v-model="newPrintOption"/>
        <div class="row mb-2">
          <div class="col">
            <BasicDropdown label="Bundle Sequence" :items="sequenceOptions" class="my-1" v-model="newBundleSequence"/>
          </div>
          <div class="col" v-if="!dropdownOptionIsNotSingleSummaryLineItemAndCost(newPrintOption)">
            <BasicTextInput label="Bundle Quantity"  type="number" class="my-1" v-model="newBundleQuantity"/>
          </div>
        </div>
        <button type="button" class="btn btn-primary" @click="createBundle">Create Bundle</button>
      </div>

    </Modal>
    <Modal  ref="editBundleModal">
      <div class="card modal-card">
        <BasicTextInput label="Bundle Title"  :focus="true" class="my-1" v-model="newBundleTitle"/>
        <BasicDropdown label="Print Options" class="my-3" @change="resetBundleQuantity" :items="bundlePrintOptionsItemsEdit" v-model="newPrintOption"/>
        <div class="row mb-2">
          <div class="col">
            <BasicDropdown label="Bundle Sequence" :items="editBundleSequenceOptions" class="my-1" v-model="newBundleSequence"/>
          </div>
          <div class="col" v-if="!dropdownOptionIsNotSingleSummaryLineItemAndCost(newPrintOption)">
            <BasicTextInput label="Bundle Quantity" type="number" class="my-1" v-model="newBundleQuantity"/>
          </div>
        </div>
        <button type="button" class="btn btn-primary" @click="editBundle">Update Bundle</button>
      </div>

    </Modal>

    <Modal ref="configuratorModalV2">
      <ConfiguratorV2 @productsAdded="handleConfiguratorAddProductsClicked"/>
    </Modal>

    <Modal ref="smartCatSearchModal">
      <SmartCatalogSearch 
        @productAdded="handleSmartCatalogSearchAddProductClicked" 
        v-on:selected:manufacturer="loadSmartCatalog" 
        v-on:selected:manufacturer:product="loadSmartCatalogProduct"/>
    </Modal>

    <Modal ref="smartCatSearchModalV2">
      <SmartCatalogSearchV2 
        @productAdded="handleSmartCatalogSearchAddProductClicked" 
        v-on:selected:manufacturer="loadSmartCatalog" 
        v-on:selected:manufacturer:product="loadSmartCatalogProduct"/>
    </Modal>

    <Modal ref="smartCatModal">
      <SmartCatalog
        ref="smartCatWrapper"
        v-on:productClick="handleProductClick"
        :manufacturerId="selectedSmartCatalogManufacturerId"/>
    </Modal>
    <Modal ref="deleteOrderLinesModal">
      <div class="card modal-wrapper p-4">
        <p class="modal-text">Are you sure you would like to delete row(s)?</p>
        <div class="btn-wrapper center">
          <button class="btn btn-secondary" @click="toggleDeleteOrderLinesModal">Cancel</button>
          <button @click="deleteRows" class="btn btn-primary">Delete</button>
        </div>
      </div>
    </Modal>

		<Modal ref="lineItemDetails">
			<LineItemDetailsDialog
				:editingRow="editingRow"
				:editingRowData="editingRowData"
				:readOnly="readOnly"
				@setProductData="setProductData"
				@saveLineItem="saveLineItem"
			/>
		</Modal>

		<Modal ref="productLineEditorModal">
			<ProductLineEditor
				:selectedRows="getSelectedRowsData()"
				@applyBulkChanges="applyBulkChanges"
				@cancel="closeProductLineEditor"
				ref="productLineEditor"
			/>
		</Modal>

	</div>
</template>

<script>
import DxDataGrid, {DxSelection,DxRowDragging, DxEditing,  DxColumn, DxButton, DxLookup, DxRequiredRule, DxSummary, DxSorting, DxTotalItem, DxPaging, DxStateStoring}       from 'devextreme-vue/data-grid';
import DxContextMenu from 'devextreme-vue/context-menu';
import DxTooltip from "devextreme-vue/tooltip"

import DescriptionComboboxSearch  from '../components/DescriptionComboboxSearch.vue';
import Configurator               from '../components/Configurator.vue';
import ConfiguratorV2             from '../components/ConfiguratorV2.vue';
import SmartCatalogSearch         from '../components/SmartCatalogSearch.vue';
import SmartCatalogSearchV2       from '../components/SmartCatalogSearchV2.vue';
import SmartCatalog               from '../components/SmartCatalog.vue';
import PercentInputAllowNegative  from '../components/inputComponents/PercentInputAllowNegative.vue';
import LineItemDetailsDialog			from '../components/LineItemDetailsDialog.vue';
import ProductLineEditor					from '../components/ProductLineEditor.vue';

import { confirm } from 'devextreme/ui/dialog';
import { mapState } from 'vuex';
import {DealerService, ProductService} from '@/services';
import { on, off } from "devextreme/events";
import { extractProdData } from "../modules/helpers";
import { OrderService } from '../services';

export default {
  name: 'CustomOrderGrid',
  props: {
    //Array of Objects containing the data used to populate the grid
    //Template: [{city: 'Atlanta', state: 'GA', phone: '(404)854-5859'}]
    dataSource:{
      type: Array,
      default: () => [],
    },
    //Headers used for mapping data to columns columns =[{text: 'Header Label', value: 'Column Value', width: '100px'}], value should match datasource property
    // columns:{
    //   type: Array,
    //   default: () => [],
    // },
    readOnly: {
      type: Boolean,
      default: false
    },
    defaultGP: {
      type: Number,
      default: 0,
    },
    OrderLineGroupName: {
      type: String,
      default: "Individual Line Items"
    },
    OrderLineGroupId: {
      type: Number,
      default: 0,
    },
    bundleIsImported: {
      type: Boolean,
      default: false,
    },
    printOptions: {
      type: Array,
      default: () => [],
    },
    sequenceOptions: {
      type: Array,
      default: () => [],
    },
    PrintOptionId: {
      type: Number,
      default: 1,
    },
    BundleQuantity: {
      type: Number | String,
      default: 1,
    },
    showColumnLines:{
      type: Boolean,
      default: false
    },
    showRowLines:{
      type: Boolean,
      default: true
    },
    alternateRowEnabled:{
      type: Boolean,
      default: true
    },
    //Options for ColumnResizing 'nextColumn' and 'widget'
    columnResizingMode: {
      type: String,
      default: 'widget'
    },
    multiSelect:{
      type: Boolean,
      default: true
    },
    cellFontSize: {
      type: String,
      default: '10px'
    },
    headerFontSize: {
      type: String,
      default: '12px'
    },
    gridIndex: {
      type: Number,
      default: 0
    },
    detailView: {
      type: Boolean,
      default: true,
    },
    // products: {
    //   type: Array,
    //   default: () => []
    // },
    roundToDollar: {
      type: Boolean,
      default: false
    },
    totalsSummary: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    DxTooltip,
    DxDataGrid,
    DxRowDragging,
    DxColumn,
    DxSelection,
    DxEditing,
    DxButton,
    DxLookup,
    DxRequiredRule,
    DxSorting,
    DxPaging,
    DxSummary,
    DxTotalItem,
    DxContextMenu,
    DescriptionComboboxSearch,
    SmartCatalogSearch,
    SmartCatalogSearchV2,
    SmartCatalog,
    Configurator,
    ConfiguratorV2,
    PercentInputAllowNegative,
    DxStateStoring,
		LineItemDetailsDialog,
		ProductLineEditor,
  },
  data() {
    return {
      isLimitedTransferUser: false,
      tooltipRefName: 'tooltip',
      filterExpr: null,
      refName: '',

      datagridUpdateKey: 0,
      summaryUpdateKey: 0,
      currentGlobalRowEditing: 0,
      currentColumnEditing: 'LineNumber',
      currentColumnEditingIndex: 0,
      newPrintOption: 4, //4 = default for None selection
      emptyProductRow: {
        OrderLineId: null,
        LineNumber: 0, 
        Quantity: 1,
        MfgCode: "",
        MfgId: null,
        PartNumber: "",
        Description: "",
        Retail: 0,
        DealerCost: 0,
        InitialDealerCost: 0,
        Discount1: 0.00,
        Discount2: 0.00,
        ImportedDiscount1: false,
        ImportedDiscount2: false,
        DealerExtended: 0.00,
        CustomerExtended: 0.00,
        CustomerCost: 0.00,
        GPPercent: 0.00,
        StockCode: '',
        OrderLineGroupName: 'Individual Line Items',
        OrderLineGroupId: 0,
        PrintOptionId: 1
      },
      summary: {},
      editing: false,
      newBundleTitle: '',
      newBundleQuantity: 1,
      newBundleSequence: 1,
      dataToCompareChangesAgainst: null, //this will be a copy of the initial data

      columnAfterComboboxDropdowns: 6,
      currentCellToolTip: '',
      selectedSmartCatalogManufacturerId: null,
      selectedDealerManufacturerId: null,
      selectedSmartCatalogManufacturerCode: null,
      ignoreAlerts: false,
      iconSetToSelectAll: true,
      theSourceIcon: null,
      isHSUS: false,
			isZAHN: false,
      maxDescriptionLength: 90,
			editingRow: null,
			editingRowData: null,
    };
  },
  methods: {
    resetBundleQuantity(option){
      if(this.dropdownOptionIsNotSingleSummaryLineItemAndCost(option)) this.newBundleQuantity = 1;
    },
    dropdownOptionIsNotSingleSummaryLineItemAndCost(option){
      return option !== 3;
    },
    selectAllClicked(){
      this.$emit('selectAll');
    },
    deselectAllClicked(){
      this.$emit('deselectAll');
    },
    selectAll(){
      if (!this.$refs[`${this.refName}`] || !this.$refs[`${this.refName}`].instance) {
        return;
      }
      this.iconSetToSelectAll = false;
      this.$refs[`${this.refName}`].instance.selectAll()
    },
    deselectAll(){
      if (!this.$refs[`${this.refName}`] || !this.$refs[`${this.refName}`].instance) {
        return;
      }
      this.iconSetToSelectAll = true;
      this.$refs[`${this.refName}`].instance.clearSelection()
    },
    toggleDeleteBundle(){
      this.$refs['deleteBundleModal'].toggle()
    },
    handleSmartCatalogSearchAddProductClicked(productData){
      let prodData = {...productData}
      prodData.Description = prodData.ProductDescription;
      this.addProductFromSmartCatalogToDataGrid(prodData);
    },
    async handleProductClick(e, MfgId){
      // attempt to get data from link address, if fails, default to info contained in link query params;
      let prodData = await this.getProductData(e, MfgId);
      this.addProductFromSmartCatalogToDataGrid(prodData);
      
    },
    async getProductData(e, MfgId){
      let prodData = extractProdData(e.productHref)
      prodData.MfgId = MfgId
      try {
       return await ProductService.getByCode(prodData);
      } catch {
        prodData.MfgId = this.selectedDealerManufacturerId;
        prodData.MfgCode = this.selectedDealerManufacturerCode;
        return prodData;
      }
    },
    launchConfiguratorModalV2(){
      this.$refs.configuratorModalV2.openModal();
    },
    openPriceGuidance() {
      window.open("https://app.powerbi.com/groups/me/apps", "_blank");
    },
		openCurrentPromotions() {
      window.open("https://app.smartsheet.com/b/publish?EQBCT=28121e7c69a248c4b5041824bdc18f9a", "_blank");
    },
    launchSmartCatalogModal(){
      this.$refs.smartCatSearchModal.openModal();
    }, 
    launchSmartCatalogModalNew(){
      this.$refs.smartCatSearchModalV2.openModal();
    }, 
    loadSmartCatalog(manufacturerId, dealerMfgId, dealerMfgCode){
      this.selectedSmartCatalogManufacturerId = null;
      this.selectedSmartCatalogManufacturerId = manufacturerId;
      this.selectedDealerManufacturerId = null;
      this.selectedDealerManufacturerId = dealerMfgId;

      this.selectedDealerManufacturerCode = null;
      this.selectedDealerManufacturerCode = dealerMfgCode;
      this.$refs.smartCatModal.openModal();
    },
    loadSmartCatalogProduct(obj){
      this.selectedSmartCatalogManufacturerId = null;
      this.selectedSmartCatalogManufacturerId = obj.manufacturerId;

      this.selectedDealerManufacturerCode = null;
      this.selectedDealerManufacturerCode = obj.dealerMfgCode;
      this.selectedDealerManufacturerId = null;
      this.selectedDealerManufacturerId = obj.dealerMfgId;
      this.selectedSmartCatalogManufacturerCode = null;
      this.selectedSmartCatalogManufacturerCode = obj.product.MfgCode;
      
      this.$refs.smartCatModal.openModal();
      this.$nextTick(() => {
        this.$refs.smartCatWrapper.setupPartNumberFilter(obj.product);
      })
    },





    addMenuItems(e){
      if (e.target == 'content') {
        // e.items can be undefined
        if (!e.items) e.items = [];
        if (!this.$refs[`${this.refName}`] || !this.$refs[`${this.refName}`].instance) {
          return;
        }
        let rows = this.$refs[`${this.refName}`].instance.getSelectedRowsData()
        // Add a custom menu item
        if(!this.readOnly){
          e.items.push({
            text: 'Product Line Editor',
            onItemClick: () => {
              if(rows.length <= 0){
                this.$store.dispatch('ADD_NOTIFICATION', { text: `Please select rows you would like to edit using the checkbox`, type: 'warning' });
                return;
              }
              this.openProductLineEditor();
            }
          });
          e.items.push({
            text: 'Refresh Pricing',
            onItemClick: () => {
              if(rows.length <= 0){
                this.$store.dispatch('ADD_NOTIFICATION', { text: `Please select rows you would like to refresh using the checkbox`, type: 'warning' });
                return
              }
              this.currentColumnEditing = ""
              this.ignoreAlerts = true;
              this.$emit('refreshPricing')

            }
          });
        }
          e.items.push({
            text: 'Copy Selected Row(s)',
            onItemClick: () => {
              // let rows = this.$refs[`${this.refName}`].instance.getSelectedRowsData()
              // if(rows.length <= 0){
              //   this.$store.dispatch('ADD_NOTIFICATION', { text: `Please select rows you would like to copy using the checkbox`, type: 'warning' });
              //   return
              // }
              // let numberOfRows = rows.length
              // rows = JSON.stringify(rows)
              // localStorage.setItem('rows', rows);
              // this.$store.dispatch('ADD_NOTIFICATION', { text: `${numberOfRows} row(s) copied`, type: 'success' });
              this.$emit('copyOrderLines')
              if (this.$refs[`${this.refName}`] && this.$refs[`${this.refName}`].instance) {
                this.$refs[`${this.refName}`].instance.clearSelection()
              }
              this.iconSetToSelectAll = true;
            }
          });
         
        if(!this.readOnly){
           e.items.push({
            text: 'Paste',
            onItemClick: () => {
              let copiedRows = JSON.parse(localStorage.getItem('rows'))
              this.addCopiedRows(copiedRows, e.row?.key ?? -1)
            }
          });
          e.items.push({
            text: 'Cut Selected Row(s)',
            onItemClick: () => {
              this.$emit('cutOrderLines')
              // this.$emit('deleteOrderLines')
              // this.$refs[`${this.refName}`].instance.clearSelection()
              this.iconSetToSelectAll = true;
            }
          });
          e.items.push({
            text: 'Delete Selected Row(s)',
            onItemClick: () => {
              if(rows.length <= 0){
                this.$store.dispatch('ADD_NOTIFICATION', { text: `Please select rows you would like to refresh using the checkbox`, type: 'warning' });
                return
              }
              // this.currentColumnEditing = ""
              this.toggleDeleteOrderLinesModal()
              // this.deleteRows();
            }
          });
					e.items.push({
            text: 'Add New Row',
            onItemClick: () => {
              this.addNewRow()
            }
          });
        }
      }
    },
    toggleDeleteOrderLinesModal(){
      this.$refs.deleteOrderLinesModal.toggle()
    },
    clearSelectedRows(){
      if (!this.$refs[`${this.refName}`] || !this.$refs[`${this.refName}`].instance) {
        return;
      }
      this.$refs[`${this.refName}`].instance.clearSelection();
      this.iconSetToSelectAll = true;
    },
    deleteRows(){
      this.$emit('deleteOrderLines')
      // let rows = this.$refs[`${this.refName}`].instance.getSelectedRowsData()
      // rows.sort(function(a,b){ return b.LineNumber - a.LineNumber; })
      // for (var i = rows.length -1; i >= 0; i--){
      //   let index = this.dataSource.map(orderLine => orderLine.LineNumber).indexOf(rows[i].LineNumber)
      //   this.dataSource.splice(index,1);
      // }
      // this.$refs[`${this.refName}`].instance.clearSelection()
      // this.datagridUpdateKey++;
      this.toggleDeleteOrderLinesModal();
      // this.$store.dispatch('ADD_NOTIFICATION', { text: "Selected Orders have been deleted" , type: 'success' });
    },
    getSelectedRowsData(){
      return this.$refs[`${this.refName}`].instance.getSelectedRowsData()
    },
    refreshPricingFinished(){
      if (!this.$refs[`${this.refName}`] || !this.$refs[`${this.refName}`].instance) {
        return;
      }
      this.$refs[`${this.refName}`].instance.clearSelection()
      this.iconSetToSelectAll = true;
      this.ignoreAlerts = false;
    },
    refreshPricing(){
      if (!this.$refs[`${this.refName}`] || !this.$refs[`${this.refName}`].instance) {
        return;
      }
      let rows = this.$refs[`${this.refName}`].instance.getSelectedRowsData()
      OrderService.refreshPricing(rows)
        .then(res => {
          //updatePricing forrows'
          this.ignoreAlerts = true;
          res.forEach(line => {
            let index = this.dataSource.map(row => row.LineNumber).indexOf(line.LineNumber)
            if(index >= 0){
              line.GPPercent = this.defaultGP;
              if(!line.CustomerCost && this.defaultGP){
                if(line.DealerCost){
                  line.CustomerCost = this.round(-(line.DealerCost/((this.defaultGP / 100) - 1)));
                } else {
                  line.CustomerCost = 0;
                }
              } else if(!line.CustomerCost){
                line.CustomerCost = this.round(line.Retail);
              }
              // line.CustomerCost = !line.CustomerCost || line.Retail
              this.dataSource[index] = line;
              this.setCalculatedValues({data: this.dataSource[index]})
              // this.$refs[`${this.refName}`].instance.saveEditData()
            }
          })
          if (this.$refs[`${this.refName}`] && this.$refs[`${this.refName}`].instance) {
            this.$refs[`${this.refName}`].instance.clearSelection()
          }
          this.datagridUpdateKey++;
        })
        .catch(err => {
          this.$store.dispatch('ADD_NOTIFICATION', { text: err.response.data.Message, type: 'error' });
        })
        .finally(() => {
          this.iconSetToSelectAll = true;
          this.ignoreAlerts = false;
        })
    },
    addCopiedRows(rows, rowIndex){
      this.currentGlobalRowEditing = undefined;
      
      let newLines = [];
      rows.forEach((row, index) => {
        row.OrderLineGroupName = this.OrderLineGroupName;
        row.OrderLineGroupId = this.OrderLineGroupId;
        row.PrintOptionId = this.PrintOptionId;
        row.LineNumber = index;
        newLines.push(this.createObjectForRow(row, true))
      })
      this.$emit('pasteOrderLines', newLines, rowIndex);
      
    },
    copy(obj){
      return JSON.parse(JSON.stringify(obj))
    },
    // DealerCostIsGreaterThanRetail(e){
    //   return e.data.DealerCost > e.data.Retail
    // },
    CustomerCostIsGreaterThanRetail(e){
      return e.data.CustomerCost > e.data.Retail
    },
    CustomerCostIsGreaterThanMaximum(e){
      return e.data.MaximumPrice && e.data.CustomerCost > e.data.MaximumPrice
    },
    CustomerCostIsLessThanMinimum(e){
      return e.data.MinimumPrice && e.data.CustomerCost < e.data.MinimumPrice
    },
    configureAdecOrderLines(orderLines){
      // this.currentColumnEditing = null;
      let newOrderLines = [];
      orderLines.forEach((line, index) => {
        // let mockE ={
        //   data: line
        // };
        // this.setCalculatedValues(mockE);
        this.currentGlobalRowEditing = index;
        line.adecLineImport = true
        let newLine = this.createObjectForRow(line)
        newOrderLines.push(newLine)
      });
      this.$emit('appendAdecOrderLines', newOrderLines  )
      // this.datagridUpdateKey++;
    },
    rowDataIsEmpty(rowData){
      return !rowData.MfgCode && !rowData.Description && !rowData.PartNumber;
    },
    setCalculatedValues(e, updateSummary = true){
      if(this.currentColumnEditing === 'PartNumber' || this.currentColumnEditing === 'MfgCode' || this.currentColumnEditing === 'Description') return;
      if(this.currentColumnEditing === 'StockCode' && this.rowDataIsEmpty(e.data)){
        ProductService.getByStockCode(e.data.StockCode)
          .then(res => {
            if(res !== null){
              this.setProductData(res)
              this.datagridUpdateKey++;
              return;
            }
          })
          .catch(err => {
            console.log('err', err)
          })
      }else{
        if(this.currentColumnEditing === 'DealerCost'){
          e.data.InitialDealerCost = this.roundToTwoDecimals(e.data.DealerCost);
        };
        if(this.currentColumnEditing === 'CustomerCost'){
          e.data.CustomerCost = this.round(e.data.CustomerCost);
        };
        if(this.currentColumnEditing === 'Retail'){
          e.data.Retail = this.roundToTwoDecimals(e.data.Retail);
        };

        // if(this.DealerCostIsGreaterThanRetail(e)){
        //   if(!this.ignoreAlerts) this.$store.dispatch('ADD_NOTIFICATION', { text: 'Dealer Cost cannot be greater than the retail cost', type: 'error' });
        //   //Add notification alerting user that dealer cost can not be higher than retailcost
        //   e.data.DealerCost = this.roundToTwoDecimals(e.data.Retail);
        //   e.data.InitialDealerCost = this.roundToTwoDecimals(e.data.DealerCost);
        // } else
        // if(e.data.DealerCost < 0){
        //   //Add notification alerting user that dealer cost can not be less than 0
        //   e.data.DealerCost = 0;
        //   e.data.InitialDealerCost = this.roundToTwoDecimals(e.data.DealerCost);
        // }
        // Only recalculate dealer cost if it wasn't manually set
        if (!e.data._manualDealerCost) {
          let costAfterDiscountA = e.data.InitialDealerCost - ((e.data.Discount1/100) * e.data.InitialDealerCost)
          e.data.DealerCost = this.roundToTwoDecimals(costAfterDiscountA - ((e.data.Discount2/100) * costAfterDiscountA))
        }
        if(this.currentColumnEditing === 'GPPercent') e.data.CustomerCost = this.round(-(e.data.DealerCost/((e.data.GPPercent / 100) - 1)));
        // if(this.currentColumnEditing !== 'CustomerCost') e.data.CustomerCost = this.round(-(e.data.DealerCost/((e.data.GPPercent / 100) - 1)));
        if(this.CustomerCostIsGreaterThanRetail(e)){
          if(!this.ignoreAlerts) this.$store.dispatch('ADD_NOTIFICATION', { text: 'Customer Cost cannot be greater than the retail cost', type: 'error' });
          e.data.CustomerCost = this.roundWithLimit(e.data.Retail);
          e.data.GPPercent = this.roundToThreeDecimals(((e.data.CustomerCost - e.data.DealerCost) / e.data.CustomerCost) * 100);
        } else if(this.CustomerCostIsGreaterThanMaximum(e)){
          if(!this.ignoreAlerts) this.$store.dispatch('ADD_NOTIFICATION', { text: `The Maximum Cost for this product is $${e.data.MaximumPrice}`, type: 'error' });
          e.data.CustomerCost = this.round(e.data.MaximumPrice);
          e.data.GPPercent = this.roundToThreeDecimals(((e.data.CustomerCost - e.data.DealerCost) / e.data.CustomerCost) * 100);
        } else if(this.CustomerCostIsLessThanMinimum(e)){
          if(!this.ignoreAlerts) this.$store.dispatch('ADD_NOTIFICATION', { text: `The Minimum Cost for this product is $${e.data.MinimumPrice}`, type: 'error' });
          e.data.CustomerCost = this.round(e.data.MinimumPrice);
          e.data.GPPercent = this.roundToThreeDecimals(((e.data.CustomerCost - e.data.DealerCost) / e.data.CustomerCost) * 100);
        }
        // else if(e.data.CustomerCost < 0){
        //   // this.$store.dispatch('ADD_NOTIFICATION', { text: 'Customer Cost cannot be greater than the retail cost', type: 'error' });
        //   //Add notification alerting user that dealer cost can not be less than 0
        //   e.data.CustomerCost = 0;
        //   e.data.GPPercent = 0;
        // }
        if(this.currentColumnEditing !== 'GPPercent'){
          if(e.data.CustomerCost === 0){
            e.data.GPPercent = 0;
          } else{
            e.data.GPPercent = this.roundToThreeDecimals(((e.data.CustomerCost - e.data.DealerCost) / e.data.CustomerCost) * 100);
          }
        }

        e.data.DealerExtended = this.roundToTwoDecimals(e.data.DealerCost * e.data.Quantity);
        e.data.CustomerExtended = this.round(e.data.CustomerCost * e.data.Quantity);
        if(updateSummary) this.summaryUpdateKey++;
      }
    },
    addProductFromSmartCatalogToDataGrid(productData){
      this.currentGlobalRowEditing = undefined;
      productData.Quantity = 1;
      let orderLine = this.createObjectForRow(productData);
      this.$emit('addProductFromSmartCatalog', orderLine)
      this.datagridUpdateKey++;
      this.$store.dispatch('ADD_NOTIFICATION', { text: `Product: ${productData.PartNumber} was added to your order`, type: 'success' });
      
    },
    handleConfiguratorAddProductsClicked(products){
      this.currentGlobalRowEditing = undefined;
      let newProducts = [];
      products.forEach((product, index) => {
        //if(!product.HasMatchingProduct && product.HasMatchingProduct !== undefined ) return;
          
        let data = {
          ...this.emptyProductRow
        }
        if(product.HasMatchingProduct !== undefined){
          data.Retail= product.RetailAmount;
          data.CustomerCost= product.CustomerCost;
          data.DealerCost= product.DealerCost;
          data.Quantity= product.Quantity;
          data.Description= product.Description;
          data.Discount1 = product.Discount1; 
          data.Discount2 = product.Discount2; 
          data.MaximumPrice = product.MaximumPrice;
          data.MinimumPrice = product.MinimumPrice;
          data.MfgCode = product.ManufacturerCode; 
          data.MfgId = product.ManufacturerId; 
          data.StockCode = product.StockCode;
          data.PartNumber = product.PartNumber;
          data.LineNumber = index;
          delete data.lineNumber
        } else {
          data.Quantity = 0;
        }
        let newProduct = this.createObjectForRow(data)
        newProducts.push(newProduct)
      })
      // this.$emit('addProductFromSmartCatalog', products[0])
      this.$emit('addProductsFromConfigurator', newProducts)
      this.datagridUpdateKey++;
      this.$store.dispatch('ADD_NOTIFICATION', { text: `Products were added to your order`, type: 'success' });
    },
    createObjectForRow(data, isCopied=false){
      let newLineNumber;
      let quantity;
      if(this.dataSource[this.currentGlobalRowEditing] === undefined){
        let maxLineNumber = 0;
        this.dataSource.forEach(line => {
          if(line.LineNumber >= maxLineNumber){
            maxLineNumber = line.LineNumber+1;
          }
        })
        // newLineNumber = maxLineNumber;
        newLineNumber = data.LineNumber ?  maxLineNumber + data.LineNumber : maxLineNumber;
        quantity = data.Quantity;
      } else{
        newLineNumber = this.dataSource[this.currentGlobalRowEditing].LineNumber;
        // quantity = this.dataSource[this.currentGlobalRowEditing].Quantity;
        quantity = data.Quantity ?? this.dataSource[this.currentGlobalRowEditing].Quantity;
      }

      if (quantity === null) quantity = 1;
      let newDealerCost = isCopied ? data.DealerCost : data.DealerCost * ( 1 - (data.Discount1/100) - (data.Discount2/100))
      let initialDealerCost = !isCopied ? data.DealerCost : data.DealerCost / ( 1 - (data.Discount1/100) - (data.Discount2/100))
      let newCustomerCost = data.CustomerCost ? data.CustomerCost : Number(data.Retail);
      // add  && newCustomerCost if we want customer cost to stay 0.
      newCustomerCost = newDealerCost && !data.CustomerCost ? -(newDealerCost/((this.getGP(newCustomerCost, newDealerCost) / 100) - 1)) : newCustomerCost;
      // let gp = this.getGP(newCustomerCost, newDealerCost)
      let gp = newCustomerCost ? ((newCustomerCost - newDealerCost) / newCustomerCost) * 100 : 0;
      //in the below if statements we reset the gp not using the getGP function because we want to avoid the default gp condition
      if(newCustomerCost > Number(data.Retail)){
        newCustomerCost = Number(data.Retail)
        gp = newCustomerCost ? ((newCustomerCost - newDealerCost) / newCustomerCost) * 100 : 0;
      }
      if(data.MaximumPrice && newCustomerCost > Number(data.MaximumPrice)){
        newCustomerCost = Number(data.MaximumPrice)
        gp = newCustomerCost ? ((newCustomerCost - newDealerCost) / newCustomerCost) * 100 : 0;
      } else if(data.MinimumPrice && newCustomerCost < Number(data.MinimumPrice)){
        newCustomerCost = Number(data.MinimumPrice)
        gp = newCustomerCost ? ((newCustomerCost - newDealerCost) / newCustomerCost) * 100 : 0;
      }

      /*
      If you look at the customer extened calc.. it seems redundant. 
      It actually is redundant, however because js treats numbers as "IEEE 754 floating point numbers", it is necessary.
      if you type 4515.23*3 into your devTools console you will see that js gives you the value of 13545.6899999999999
      instead of 13545.69

      */

      const description = data?.Description ? data.Description : ''

      let orderLine = {
        ...this.emptyProductRow,
        LineNumber: newLineNumber,
        Description: description.replace("\uFFFD", "'"),
        Discount1: data.Discount1 || 0,
        Discount2: data.Discount2 || 0,
        ImportedDiscount1: (data.Discount1 && !isCopied) ? true : false,
        ImportedDiscount2: (data.Discount2 && !isCopied) ? true : false,
        PartNumber: data.PartNumber,
        MaximumPrice: data.MaximumPrice,
        MinimumPrice: data.MinimumPrice,
        MfgId: data.MfgId,
        MfgCode: data.MfgCode,
        InitialDealerCost: this.roundToTwoDecimals(initialDealerCost) || 0,
        DealerCost: this.roundToTwoDecimals(newDealerCost) || 0,
        CustomerCost: this.round(newCustomerCost),
        DealerExtended: this.roundToTwoDecimals(newDealerCost * quantity),
        CustomerExtended: this.round(this.round(newCustomerCost) * quantity),
        GPPercent: this.roundToThreeDecimals(gp),
        StockCode: data.StockCode,
        Retail: this.roundToTwoDecimals(data.Retail) || 0,
        Quantity: quantity,
        OrderLineGroupName: data.adecLineImport ? data.OrderLineGroupName : this.OrderLineGroupName,
        OrderLineGroupId: data.adecLineImport ? data.OrderLineGroupId : this.OrderLineGroupId,
        PrintOptionId: data.adecLineImport ? data.PrintOptionId : this.PrintOptionId,
      }
      return orderLine;
    },
    getGP(customerCost, dealerCost){
      return this.defaultGP ?
      this.defaultGP :
      customerCost === 0 || customerCost === null ? 0 : ((customerCost - dealerCost) / customerCost) * 100  ;
    },
    setProductData(data, e){
      if(!this.addingNewRow()){
        this.dataSource[this.currentGlobalRowEditing] = this.createObjectForRow(data)
        this.dataToCompareChangesAgainst[this.currentGlobalRowEditing] = this.copy(this.dataSource[this.currentGlobalRowEditing])
        if (!this.$refs[`${this.refName}`] || !this.$refs[`${this.refName}`].instance) {
          return;
        }
        var grid = this.$refs[`${this.refName}`].instance;
        // grid.saveEditData();
        grid.focus(grid.getCellElement(this.localRow, this.columnAfterComboboxDropdowns));
        grid.editCell(this.localRow, this.columnAfterComboboxDropdowns);
        this.currentColumnEditingIndex = this.columnAfterComboboxDropdowns;

      }
    },
    addingNewRow(){      
      return this.currentGlobalRowEditing >= this.dataSource.length
    },
    dataHasBeenChangedByUser(data){
      let row = this.dataToCompareChangesAgainst[data.rowIndex]

      // return data.value !== row[data.column.dataField]
      return false // the above statement is what I will want.. but for now I am disabling this feature
    },
		calculateAmountClass(data) {
			let cellClass = 'cell'
			if (this.dataHasBeenChangedByUser(data)) {
				cellClass = 'cell-edited';
			}

			if (data.value < 0) {
				cellClass += ' cell-negative';
			}

			return cellClass;
		},
		calculateSummaryClass(type) {
			const value = this.summary ? this.summary[type] : 0;
			return value < 0 ? 'summary-text-custom-order-grid negative-value-red' : 'summary-text-custom-order-grid';
		},
    onEditingStart(e){
      this.currentGlobalRowEditing = this.dataSource.map(item => item.LineNumber).indexOf(e.data.LineNumber)
      this.currentColumnEditing = e.column.dataField
      this.currentColumnEditingIndex = e.column.index
    },
    calculateSummary(options) {
      //should probably make this a switch
      if (options.name === 'SubtotalLabel') {
        options.totalValue = 'Subtotal:';
        
      }
      else if (options.name === 'retailSummary') {
        if (options.summaryProcess === 'start') {
          options.totalValue = 0;
        } else if (options.summaryProcess === 'calculate') {
					if (options.value.Quantity < 0) {
						options.value.Quantity = 0;
					}

          if(options.value.Quantity && options.value.Retail){
            options.totalValue = options.totalValue + (options.value.Retail * options.value.Quantity);
          }
        } else if (options.summaryProcess === 'finalize') {
					if (!this.summary) {
						this.summary = {};
					}

					this.summary.retail = this.roundToTwoDecimals(options.totalValue);
          options.totalValue = this.formatCurrency(options.totalValue);
        }
      }
      else if (options.name === 'DealerCostSummary') {
        if (options.summaryProcess === 'start') {
          options.totalValue = 0;
        } else if (options.summaryProcess === 'calculate') {
          if(options.value.DealerCost){
            options.totalValue = options.totalValue + options.value.DealerCost;
          }
        } else if (options.summaryProcess === 'finalize') {
					this.summary.dealerCostSummary = this.roundToTwoDecimals(options.totalValue);
          options.totalValue = this.formatCurrency(options.totalValue);
        }
      }
      else if (options.name === 'DealerExtendedSummary') {
        if (options.summaryProcess === 'start') {
          options.totalValue = 0;
        } else if (options.summaryProcess === 'calculate') {
          if(options.value.DealerExtended){
            options.totalValue = options.totalValue + options.value.DealerExtended;
          }
        } else if (options.summaryProcess === 'finalize') {
          this.summary.dealerCost = this.roundToTwoDecimals(options.totalValue);
          options.totalValue = this.formatCurrency(options.totalValue);
        }
      }
      else if (options.name === 'CustomerCostSummary') {
        if (options.summaryProcess === 'start') {
          options.totalValue = 0;
        } else if (options.summaryProcess === 'calculate') {
          if(options.value.CustomerCost){
            options.totalValue = options.totalValue + options.value.CustomerCost;
          }
        } else if (options.summaryProcess === 'finalize') {
					this.summary.customerCostSummary = this.roundToTwoDecimals(options.totalValue);
          options.totalValue = this.formatCurrency(options.totalValue);
        }
      }
      else if (options.name === 'CustomerExtendedSummary') {
        if (options.summaryProcess === 'start') {
          options.totalValue = 0;
        } else if (options.summaryProcess === 'calculate') {
          if(options.value.CustomerExtended){
            options.totalValue = options.totalValue + options.value.CustomerExtended;
          }
        } else if (options.summaryProcess === 'finalize') {
          this.summary.subtotal = this.round(options.totalValue);
          options.totalValue = this.formatCurrency(options.totalValue);
        }
        
      }
      else if (options.name === 'Discount1Summary') {
        if (options.summaryProcess === 'start') {
          options.totalValue = 0;
          options.totalCount = 0;
        } else if (options.summaryProcess === 'calculate') {
          if(options.value.Discount1){
            options.totalValue = options.totalValue + options.value.Discount1;
            options.totalCount ++;
          }
        } else if (options.summaryProcess === 'finalize') {
          options.totalValue = this.formatPercent(options.totalValue/options.totalCount);
        }
      }
      else if (options.name === 'Discount2Summary') {
        if (options.summaryProcess === 'start') {
          options.totalValue = 0;
          options.totalCount = 0;
        } else if (options.summaryProcess === 'calculate') {
          if(options.value.Discount2){
            options.totalValue = options.totalValue + options.value.Discount2;
            options.totalCount ++;
          }
        } else if (options.summaryProcess === 'finalize') {
          options.totalValue = this.formatPercent(options.totalValue/options.totalCount);
        }
      }
      else if (options.name === 'GPPercentSummary') {
        if (options.summaryProcess === 'start') {
          options.totalValue = 0;
          options.totalCount = 0;
        } else if (options.summaryProcess === 'calculate') {
          if(options.value.GPPercent){
            options.totalValue = options.totalValue + options.value.GPPercent;
            options.totalCount ++;
          }
        } else if (options.summaryProcess === 'finalize') {
          options.totalValue = this.formatPercent(options.totalValue/options.totalCount);
        }
      }
    },

    roundToTwoDecimals(data){
      if(Number(data) === 'NaN') return;
      return Number(Number(data).toFixed(2));
    },
    roundToThreeDecimals(data){
      if(Number(data) === 'NaN') return;
      return Number(Number(data).toFixed(3));
    },
		roundWithLimit(data){
      if(Number(data) === 'NaN') return;

			const limit = Number(data);
			const calculatedValue = this.round(data);
			return calculatedValue > limit ? this.roundToDollar ? Math.floor(limit) : limit : calculatedValue;
    },
    round(data){
      if(Number(data) === 'NaN') {
        return;
      };

      return this.roundToDollar ? Math.ceil(Number(data)) : this.roundToTwoDecimals(Number(data));
    },
    deleteBundle(){
      this.$emit('deleteBundle', this.OrderLineGroupId )
    },
    deleteBundleAndKeepOrderLines(){
      this.$emit('deleteBundleAndKeepOrderLines', this.OrderLineGroupId )
    }, 
    clearNewBundleData(){
      this.newBundleTitle="";
      this.newPrintOption=1;
      this.newBundleQuantity=1;
      this.newBundleSequence = this.sequenceOptions[this.sequenceOptions.length-1].value;
    },
    toggleEditBundleModal(){
      this.clearNewBundleData();
      this.$refs.editBundleModal.toggle()
    },
    openEditBundleModal(){
      this.newPrintOption = this.PrintOptionId;
      this.newBundleTitle = this.OrderLineGroupName;
      this.newBundleSequence = this.OrderLineGroupId;
      this.newBundleQuantity = this.BundleQuantity;
      this.$refs.editBundleModal.toggle()
    },
    toggleCreateBundleModal(){
      this.clearNewBundleData();
      this.$refs.bundleModal.toggle()
    },
    editBundle(){
      let bundle = {
        OrderLineGroupName: this.newBundleTitle,
        PrintOptionId: this.newPrintOption,
        OrderLineGroupId: this.OrderLineGroupId,
        IsImported: this.bundleIsImported,
        Quantity: this.newBundleQuantity,
        Sequence: this.newBundleSequence,
      }
      this.$emit('editBundle', bundle);
      this.toggleEditBundleModal();
    },
    createBundle(){
      if (!this.$refs[`${this.refName}`] || !this.$refs[`${this.refName}`].instance) {
        return;
      }
      let data = this.$refs[`${this.refName}`].instance.getSelectedRowsData()
      data.forEach(item => {
        item.OrderLineGroupName = this.newBundleTitle;
        item.OrderLineGroupId = -1;
        item.PrintOptionId = this.newPrintOption;
      })
      this.$emit('createNewBundle', this.newBundleTitle, this.newPrintOption, this.newBundleSequence, this.newBundleQuantity )
      this.toggleCreateBundleModal()
    },
    formatCurrency(currency){
      if(typeof(currency) !== 'number') return;
      if(currency === 0 || currency === null) return ''
      return currency.toFixed(2);
    },
    formatPercent(percent){
      if(typeof(percent) !== 'number') return;
      if(percent  === 0 || percent === null) return ''
      return percent.toFixed(2);
    },
		dataIsNoMatch(data) {
			return data.row.data.MfgCode && data.row.data.PartNumber && !data.value;
		},
    onReorder(e) {
      e.component.closeEditCell();
      var visibleRows = e.component.getVisibleRows(),
        toIndex = this.dataSource.indexOf(visibleRows[e.toIndex].data),
        fromIndex = this.dataSource.indexOf(e.itemData);
      this.dataSource.splice(fromIndex, 1);
      this.dataSource.splice(toIndex, 0, e.itemData);
      this.$emit('updateOrderLineNumbers')
    },
    onAdd(e) {
      e.itemData.OrderLineGroupId = e.toData;
      let lineNumber = e.itemData.LineNumber
      let bundleId = e.toData
      this.$emit('updateData', lineNumber, bundleId);
    }, 
    onEditorPreparing(e){
      if(e.row && e.row.isNewRow){
        if (!this.$refs[`${this.refName}`] || !this.$refs[`${this.refName}`].instance) {
          return;
        }
        this.$refs[`${this.refName}`].instance.saveEditData();
      }

      if(e.dataField === 'Discount1'){
        e.editorOptions.disabled = e.parentType === "dataRow" && e.row.data.ImportedDiscount1;
      }
      if(e.dataField === 'Discount2'){
        e.editorOptions.disabled = e.parentType === "dataRow" && e.row.data.ImportedDiscount2;
      }   
      if(e.dataField === 'DealerCost'){
        e.editorOptions.disabled = e.parentType === "dataRow" && (e.row.data.ImportedDiscount1 || e.row.data.ImportedDiscount2);
      }
    },
    addNewRow() {
        if (!this.$refs[`${this.refName}`] || !this.$refs[`${this.refName}`].instance) {
          return;
        }
        this.$refs[`${this.refName}`].instance.addRow();
        this.$emit('itemHasBeenAdded')
    },
    initNewRow(e){
      let newLineNumber = 0;
      this.dataSource.forEach(item => {
        if(item.LineNumber >= newLineNumber) newLineNumber = item.LineNumber + 1;
      })
      e.data = {
        ...this.emptyProductRow,
        OrderLineGroupName: this.OrderLineGroupName,
        OrderLineGroupId: this.OrderLineGroupId,
        PrintOptionId: this.PrintOptionId,
        LineNumber: newLineNumber
      } 
      this.dataToCompareChangesAgainst.push(e.data)
    },
    onCellPrepared(e) {
      if (e.rowType === "header" && e.column.caption) {
        var self = this;
        on(e.cellElement, "mouseover", arg => {
            self.currentCellToolTip = e.column.caption;
            self.$refs[self.tooltipRefName].instance.show(arg.target);
        });
        on(e.cellElement, "mouseout", arg => {
          self.$refs[self.tooltipRefName].instance.hide();
        });
      }
    },

    getCustomIcons(){
      let dealerId = this.currentUser.DealerId;
      if (!dealerId) return;
      DealerService.customIcons(dealerId).then(res => {
          this.theSourceIcon = res.find(x => ['HSD Literature', 'The Source'].includes(x.IconLabel))
      }).catch(err => {
          console.error(err);
      })
    },
    
    getDealerInfo(){
      let dealerId = this.currentUser.DealerId;
      DealerService.get(dealerId)
        .then(res => {
            //this.dealer = res;
            this.isHSUS = res.StoreCode === 'HSUS'
						this.isZAHN = res.StoreCode === 'ZAHN'
            this.maxDescriptionLength = res.MaxDescriptionLength
        })
        .catch(err => {
            console.log('err', err)
        })
    },
		lineDetails(e) {
			this.editingRow = e.row;
			this.editingRowData = JSON.parse(JSON.stringify(e.row.data))
			this.editingRowData.dataIndex = e.row.dataIndex;
			this.editingRowData.maxDataIndex = this.findMaxDataIndex(e.row);
			this.toggleLineItemDetailsModal();
		},
		findMaxDataIndex(row) {
			const orderLine = this.dataSource[row.key];
			const orderLineGroupId = orderLine.OrderLineGroupId;

			const bundleItems = this.dataSource.filter(x => x.OrderLineGroupId === orderLineGroupId);
			return bundleItems.length;
		},
		toggleLineItemDetailsModal() {
      this.$refs.lineItemDetails.toggle()
		},
		openProductLineEditor() {
			this.$refs.productLineEditorModal.toggle();
		},
		closeProductLineEditor() {
			this.$refs.productLineEditorModal.toggle();
		},
		getSelectedRowsData() {
			if (!this.$refs[`${this.refName}`] || !this.$refs[`${this.refName}`].instance) {
				return [];
			}
			return this.$refs[`${this.refName}`].instance.getSelectedRowsData();
		},
		applyBulkChanges(changes) {
			// Emit event to parent to handle applying changes across all grids
			this.$emit('applyBulkChanges', changes);

			// Close the modal and reset the form (only this grid's modal is open)
			this.$refs.productLineEditor.finishProcessing();
			this.closeProductLineEditor();
		},
		applyBulkChangesToGrid(changes) {
			if (!this.$refs[`${this.refName}`] || !this.$refs[`${this.refName}`].instance) {
				return;
			}
			const rows = this.$refs[`${this.refName}`].instance.getSelectedRowsData();

			// Skip if no rows are selected in this grid
			if (rows.length === 0) {
				return;
			}

			this.ignoreAlerts = true;

			// Check if both dealer cost and discounts are being applied
			const hasDealerCostChange = changes.dealerCost !== undefined;
			const hasDiscountChanges = (changes.discountA !== undefined) || (changes.discountB !== undefined);

			// Batch process all rows first
			rows.forEach(row => {
				// Apply quantity change
				if (changes.quantity !== undefined) {
					this.currentColumnEditing = 'Quantity';
					row.Quantity = Number(changes.quantity);
				}

				// When both dealer cost and discounts are provided, apply dealer cost adjustment first
				if (hasDealerCostChange && hasDiscountChanges) {
					// Step 1: Apply dealer cost percentage to modify InitialDealerCost
					this.currentColumnEditing = 'DealerCost';
					const dealerCostPercentage = Math.abs(Number(changes.dealerCost)) / 100;
					const adjustedDealerCost = row.Retail - (row.Retail * dealerCostPercentage);

					// Update InitialDealerCost so that discounts will be calculated from this new base
					row.InitialDealerCost = this.roundToTwoDecimals(adjustedDealerCost);
					row.DealerCost = this.roundToTwoDecimals(adjustedDealerCost);

					// Step 2: Apply discounts on top of the new dealer cost
					if (changes.discountA !== undefined && !row.ImportedDiscount1) {
						row.Discount1 = Number(changes.discountA);
					}
					if (changes.discountB !== undefined && !row.ImportedDiscount2) {
						row.Discount2 = Number(changes.discountB);
					}

					// Clear manual dealer cost flag so setCalculatedValues will apply discounts
					row._manualDealerCost = false;
				} else {
					// Original behavior when only discounts OR only dealer cost is changed

					// Apply discount A change
					if (changes.discountA !== undefined && !row.ImportedDiscount1) {
						this.currentColumnEditing = 'Discount1';
						row.Discount1 = Number(changes.discountA);
						// Clear manual dealer cost flag since discounts affect dealer cost calculation
						row._manualDealerCost = false;
					}

					// Apply discount B change
					if (changes.discountB !== undefined && !row.ImportedDiscount2) {
						this.currentColumnEditing = 'Discount2';
						row.Discount2 = Number(changes.discountB);
						// Clear manual dealer cost flag since discounts affect dealer cost calculation
						row._manualDealerCost = false;
					}

					// Apply dealer cost change (as percentage of retail - matches original standalone behavior)
					if (changes.dealerCost !== undefined) {
						this.currentColumnEditing = 'DealerCost';
						// Calculate dealer cost from retail using percentage
						// Original formula: Retail - (Retail * percent/100)
						// e.g., if dealerCost = 50 and Retail = $150
						// then DealerCost = $150 - ($150 * 0.50) = $75
						row.DealerCost = row.Retail - (row.Retail * (Math.abs(Number(changes.dealerCost)) / 100));
						// Mark this row as having a manually set dealer cost to prevent recalculation
						row._manualDealerCost = true;
					}
				}

				// Apply gross profit change
				if (changes.grossProfit !== undefined) {
					this.currentColumnEditing = 'GPPercent';
					row.GPPercent = Number(changes.grossProfit);
				}

				// Apply customer cost change (as percentage of retail - matches original standalone behavior)
				if (changes.customerCost !== undefined) {
					this.currentColumnEditing = 'CustomerCost';
					// Calculate customer cost from retail using percentage
					// Original formula: Retail - (Retail * percent/100)
					// e.g., if customerCost = 50 and Retail = $150
					// then CustomerCost = $150 - ($150 * 0.50) = $75
					row.CustomerCost = row.Retail - (row.Retail * (Math.abs(Number(changes.customerCost)) / 100));
				}

				// Recalculate values for this row
				const setRowToMatchNeededObject = { data: row };
				this.setCalculatedValues(setRowToMatchNeededObject, false);
			});

			// Save all changes at once instead of per row
			if (this.$refs[`${this.refName}`] && this.$refs[`${this.refName}`].instance) {
				this.$refs[`${this.refName}`].instance.saveEditData();
			}

			// Update summary once at the end
			this.summaryUpdateKey++;

			// Clean up
			this.ignoreAlerts = false;
			this.datagridUpdateKey++;

			// Clear selection after applying bulk changes
			this.$nextTick(() => {
				if (this.$refs[`${this.refName}`] && this.$refs[`${this.refName}`].instance) {
					this.$refs[`${this.refName}`].instance.clearSelection();
					this.iconSetToSelectAll = true;
				}
			});
		},
		saveLineItem(finalRowIndex) {
			if (finalRowIndex !== this.editingRow.dataIndex) {
				const fromIndex = Number(this.editingRow.key);
				const toIndex = fromIndex + (finalRowIndex - Number(this.editingRow.dataIndex));

				this.dataSource.splice(fromIndex, 1);
				this.dataSource.splice(toIndex, 0, this.editingRowData);
				this.$emit('updateOrderLineNumbers')
			}

			this.editingRow.data.Description = this.editingRowData.Description;
			this.editingRow.data.Quantity = this.editingRowData.Quantity;
			this.editingRow.data.MfgCode = this.editingRowData.MfgCode;
			this.editingRow.data.PartNumber = this.editingRowData.PartNumber;
			this.editingRow.data.StockCode = this.editingRowData.StockCode;
			this.editingRow.data.Retail = this.editingRowData.Retail;
			this.editingRow.data.DealerCost = this.editingRowData.DealerCost;
			this.editingRow.data.Discount1 = this.editingRowData.Discount1;
			this.editingRow.data.Discount2 = this.editingRowData.Discount2;
			this.editingRow.data.GPPercent = this.editingRowData.GPPercent;
			this.editingRow.data.CustomerCost = this.editingRowData.CustomerCost;

			this.currentColumnEditing = "";
			this.setCalculatedValues({ data: this.editingRow.data });

			this.toggleLineItemDetailsModal();
		},
		lineDelete(e) {
			let result = confirm("Are you sure you want to delete this order line?", "Confirm Delete");
			result.then((dialogResult) => {
				if (dialogResult) {
					let index = this.dataSource.map(orderLine => orderLine.LineNumber).indexOf(e.row.data.LineNumber)
					this.dataSource.splice(index, 1);
					++this.datagridUpdateKey;
				}
			});
		},
  },

  mounted() {
      this.getDealerInfo();
      this.getCustomIcons();
      this.isLimitedTransferUser = this.currentUser.IsLimitedTransferUser;
  },

  watch: {
    summary: {
      deep: true,
      handler(){
        this.$emit('updateTotalsValues', this.summary, this.OrderLineGroupId)
      }
    },
  },

  computed: {
    ...mapState(['currentUser']),
    editBundleSequenceOptions(){
      let options = [...this.sequenceOptions];
      options.pop();
      return options;
    },
    localRow(){
      let row = 0;
      let finalRow = 0;
      this.dataSource.forEach(obj => {
        if(obj.OrderLineGroupId === this.OrderLineGroupId){
          row++;
          if(obj.LineNumber === this.currentGlobalRowEditing){
            finalRow = row;
          }
        }
      })
      return finalRow - 1;
    },
    printOptionsItems() {
      let options = []
      this.printOptions.forEach(option => {
        options.push({
          text: option.DisplayName,
          value: option.Id
        })
      })
      return options;
    },
    bundlePrintOptionsItemsEdit(){
        return this.printOptionsItems.filter(option => {
            return this.bundleIsImported || (!this.bundleIsImported && option.value !== 5);
        })
    },
    bundlePrintOptionsItemsNew(){
        return this.printOptionsItems.filter(option => {
            return option.value !== 5;
        })
    },
  },
  created(){
    this.refName = 'customOrderGrid' + this.OrderLineGroupId;
    this.filterExpr = ['OrderLineGroupId', '=', this.OrderLineGroupId]
    this.dataToCompareChangesAgainst = this.copy(this.dataSource)
    this.loading = true
    this.newBundleSequence = this.OrderLineGroupId
    this.summary = this.totalsSummary
  }
};
</script>
<style lang="scss" scoped>
  .order-grid-wrapper{
    max-width: 100%;
    width: 100%;
    min-width: 100%;
    overflow-x: scroll;
  }
  .header {
    color: $primary;
    font-size: 16px;
  }
  td{
    padding: 0px !important;
  }
  .cell {
    font-size: 13px;
    color: $ss_grey1;
    padding: 0px;
    &-edited{
      padding: 0px;
      color: $primary;
    }
  }
  
  .modal-card {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 10px;
    width: 400px;
    height: 100%;
  }
  .subheader-wrapper{
    display: flex;
    justify-content: space-between;
    align-items: center;
    .bundle-relocate-wrapper{
      display: flex;
      flex-direction: column;
      margin-left: 10px;
      cursor: pointer;
    }
    .bundle-relocate-icon:hover{
      background-color: $secondary
    }
    .icon-group{
      color: $primary;
      i{
        margin: 5px;
        cursor: pointer;
      }
    }
  }
  .tooltipContent div {
    text-align: left;
  }

	.no-match {
		background-color: red;
	}

	.cell-negative {
		color: red!important;
	}

	.lineItemDetailsModal {
		width: 900px!important;
		font-size: 16px!important;
	}

	.lineItemDetailsTitle {
		font-size: 20px!important;
		font-weight: 600;
		text-align: center;
		height: 20px;
		margin-top: -20px;
	}

	.lineItemRow {
		margin-bottom: 10px;
	}

	#lineItemSave {
		margin-top: 25px;
		float: right;
	}

  .modal-wrapper{
        width: 400px;
        display: flex;
        font-size: 1.2em;
        justify-content: space-around;
        align-items: center;
        .modal-text{
          text-align: center;
          margin-top: 10px;
          margin-bottom: 0px;
        }
        .btn-wrapper{
            margin-top: 25px;
            width: 100%;
            display: flex;
            justify-content: flex-end;
            align-items: flex-end;
            .btn{
              min-height: 100%;
              min-width: 125px;
            }
            &.center{
                justify-content: space-around;
                align-items: center;
            }
        }
    }
</style>
